"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _services = require("../../services");
var _Header = _interopRequireDefault(require("../Recommendation/Header"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const UpsellHeader = () => {
  return /*#__PURE__*/_react.default.createElement(_Header.default, {
    id: "upsell-header",
    headerText: _services.locale.localeString('RelationshipOffer.Header'),
    headerTextWeight: 1,
    headerTextSize: 2
  });
};
var _default = UpsellHeader;
exports.default = _default;